import { Button, Grid, Popover } from '@material-ui/core'
import BombillaOutlined from 'images/icons/questionnarie/BombillaOutlined'
import CabezaPsychology from 'images/icons/questionnarie/CabezaPsychology'
import GorroSchoolIcon from 'images/icons/questionnarie/GorroSchoolIcon'
import HistoryEduIcon from 'images/icons/questionnarie/HistoryEduIcon'
import MonitoringIcon from 'images/icons/questionnarie/MonitoringIcon'
import NutIcon from 'images/icons/questionnarie/NutIcon'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useStateValue } from 'context/store'
import { userSettingsModule } from 'utils/utils'
const { makeStyles } = require('@material-ui/core')

const questionnaireStyles = makeStyles(theme => ({
   rootPopover: {
      maxHeight: '86%'
   },
   paperPopover: {
      height: 'auto'
   },
   buttonItemCuestionarioPadre: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'white',
      padding: '.4rem 1rem',
      borderRadius: '5px',
      color: '#43496A1',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      },
      '&:focus': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      }
   },
   buttonItemCuestionario: {
      backgroundColor: 'white',
      padding: '.8rem',
      borderRadius: '5px',
      color: '#43496A1',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      }
   },
   popoverFormContainer: {
      display: 'flex',
      // flex: '1 1 auto',
      width: '237px',
      padding: '1rem',
      flexDirection: 'column',
      gap: '.5rem'
   }
}))

function GestionAprendizajeButton({
   setViewQuestionnarie,
   isInitialCard = false
}) {
   const classes = questionnaireStyles()
   const [anchorElMainCard, setAnchorElMainCard] = useState(null)
   const [anchorElCuestionario, setAnchorElCuestionario] = useState(null)
   const [anchorElCursoButton, setAnchorElCursoButton] = useState(null)
   const [anchorElConfigurationButton, setAnchorElConfigurationButton] =
      useState(null)

   const openMainCard = Boolean(anchorElMainCard)
   const openCuestionario = Boolean(anchorElCuestionario)
   const openCursoButton = Boolean(anchorElCursoButton)
   const openConfigurationButton = Boolean(anchorElConfigurationButton)

   // ID for poovers:
   const idMainCard = openMainCard ? 'simple-popover' : undefined
   const idCuestionario = openCuestionario
      ? 'simple-popover-cuestionario'
      : undefined
   const idCursoButton = openCursoButton ? 'simple-popover-curso' : undefined
   const idConfigurationButton = openConfigurationButton
      ? 'simple-popover-curso'
      : undefined

   // hableClose:
   const handleCloseMainCard = () => {
      setAnchorElMainCard(null)
   }
   const handleCloseCuestionario = () => {
      setAnchorElCuestionario(null)
   }
   const handleCloseCursoButton = () => {
      setAnchorElCursoButton(null)
   }
   const handleCloseConfigurationButton = () => {
      setAnchorElConfigurationButton(null)
   }

   // hableClick:
   const handleClickMainCard = event => {
      setAnchorElMainCard(event?.currentTarget)
   }
   const handleClickCuestionario = event => {
      setAnchorElCuestionario(event.currentTarget)
   }
   const handleClickCursoButton = event => {
      setAnchorElCursoButton(event.currentTarget)
   }
   const handleClickConfigurationButton = event => {
      setAnchorElConfigurationButton(event.currentTarget)
   }

   const [{ questionaries }, dispatch] = useStateValue()

   const createQuestionnaire = () => {
      dispatch({
         type: 'SaveQuest',
         questionaries: null
      })
      handleCloseMainCard()
      handleCloseCuestionario()
      setViewQuestionnarie('view-initial-form-questionnaire')
   }
   const goToConfigurationQuestionnarie = () => {
      handleCloseMainCard()
      handleCloseConfigurationButton()
      setViewQuestionnarie('view-configuration-questionnaire')
   }
   const searchQuestionnaire = () => {
      dispatch({
         type: 'SaveQuest',
         questionaries: null,
         name: null,
         des: null
      })
      setViewQuestionnarie('view-search-questionnaire')
   }
   useEffect(() => {
      if (isInitialCard) {
         const gestionAprendizajeButton = document.getElementById(
            'gestion-aprendizaje-button'
         )
         setAnchorElMainCard(gestionAprendizajeButton)
      }
   }, [])

   return (
      <div>
         <Button
            aria-describedby={idMainCard}
            startIcon={<BombillaOutlined color="#3264DC" />}
            color="primary"
            variant="outlined"
            onClick={handleClickMainCard}
            id="gestion-aprendizaje-button"
         >
            GESTIÓN DE APRENDIZAJE
         </Button>
         <Popover
            id={idMainCard}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            anchorEl={anchorElMainCard}
            open={openMainCard}
            onClose={handleCloseMainCard}
            classes={{
               root: classes.rootPopover,
               paper: classes.paperPopover
            }}
         >
            <Grid className={classes.popoverFormContainer}>
               <div
                  aria-describedby={idCuestionario}
                  className={classes.buttonItemCuestionarioPadre}
                  onClick={handleClickCuestionario}
               >
                  <div
                     style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.7rem'
                     }}
                  >
                     <CabezaPsychology color="#3264DC" />
                     <p>Cuestionario</p>
                  </div>

                  <ArrowRightOutlinedIcon />
               </div>

               {/* <div
                  aria-describedby={idCursoButton}
                  className={classes.buttonItemCuestionarioPadre}
                  onClick={handleClickCursoButton}
               >
                  <div
                     style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.7rem'
                     }}
                  >
                     <GorroSchoolIcon color="#3264DC" />
                     <p> Curso</p>
                  </div>

                  <ArrowRightOutlinedIcon />
               </div>
               <div className={classes.buttonItemCuestionarioPadre}>
                  <div
                     style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.7rem'
                     }}
                  >
                     <MonitoringIcon color="#3264DC" />
                     <p> Informes</p>
                  </div>
               </div>
               <div className={classes.buttonItemCuestionarioPadre}>
                  <div
                     style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.7rem'
                     }}
                  >
                     <HistoryEduIcon color="#3264DC" />
                     <p> Auditorias</p>
                  </div>
               </div> */}
               {userSettingsModule.buscarValorEnUserSettings(
                  'operations',
                  'REGISTRAR CONFIGURACION'
               ) && (
                  <div
                     onClick={handleClickConfigurationButton}
                     aria-describedby={idConfigurationButton}
                     className={classes.buttonItemCuestionarioPadre}
                  >
                     <div
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '.7rem'
                        }}
                     >
                        <NutIcon color="#3264DC" />
                        <p>Configuración</p>
                     </div>
                     <ArrowRightOutlinedIcon />
                  </div>
               )}
            </Grid>
         </Popover>
         <Popover
            id={idCuestionario}
            anchorOrigin={{
               vertical: 'center',
               horizontal: 'right'
            }}
            transformOrigin={{
               vertical: 'center',
               horizontal: 'left'
            }}
            anchorEl={anchorElCuestionario}
            open={openCuestionario}
            onClose={handleCloseCuestionario}
            classes={{
               root: classes.rootPopover,
               paper: classes.paperPopover
            }}
         >
            <Grid className={classes.popoverFormContainer}>
               {userSettingsModule.buscarValorEnUserSettings(
                  'operations',
                  'CREAR CUESTIONARIO'
               ) && (
                  <div
                     className={classes.buttonItemCuestionario}
                     onClick={() => createQuestionnaire()}
                  >
                     Crear cuestionario
                  </div>
               )}
               {userSettingsModule.buscarValorEnUserSettings(
                  'operations',
                  'CONSULTAR CUESTIONARIO'
               ) && (
                  <div
                     className={classes.buttonItemCuestionario}
                     onClick={() => searchQuestionnaire()}
                  >
                     Consultar cuestionario
                  </div>
               )}
            </Grid>
         </Popover>
         <Popover
            id={idCursoButton}
            anchorOrigin={{
               vertical: 'center',
               horizontal: 'right'
            }}
            transformOrigin={{
               vertical: 'center',
               horizontal: 'left'
            }}
            anchorEl={anchorElCursoButton}
            open={openCursoButton}
            onClose={handleCloseCursoButton}
            classes={{
               root: classes.rootPopover,
               paper: classes.paperPopover
            }}
         >
            <Grid className={classes.popoverFormContainer}>
               <div className={classes.buttonItemCuestionario}>Crear curso</div>
               <div className={classes.buttonItemCuestionario}>
                  Consultar curso
               </div>
            </Grid>
         </Popover>
         <Popover
            id={idConfigurationButton}
            anchorOrigin={{
               vertical: 'center',
               horizontal: 'right'
            }}
            transformOrigin={{
               vertical: 'center',
               horizontal: 'left'
            }}
            anchorEl={anchorElConfigurationButton}
            open={openConfigurationButton}
            onClose={handleCloseConfigurationButton}
            classes={{
               root: classes.rootPopover,
               paper: classes.paperPopover
            }}
         >
            <Grid className={classes.popoverFormContainer}>
               <div
                  className={classes.buttonItemCuestionario}
                  onClick={goToConfigurationQuestionnarie}
               >
                  Crear configuración
               </div>
               {/* <div className={classes.buttonItemCuestionario}>
                  Consultar configuración
               </div> */}
            </Grid>
         </Popover>
      </div>
   )
}

export default GestionAprendizajeButton
